export const ADMIN_EMAILS = ['akimotode@gmail.com', 'whymenotothers@gmail.com'];

export function isAdminEmail(email: string | null | undefined): boolean {
  return !!email && ADMIN_EMAILS.includes(email);
}
